import React, { Component } from "react";
import styled from "styled-components";
import { MdPayment } from "react-icons/md";

export class Transactions extends Component {
  render() {
    return (
      <Container>
        <Header>
          <HeaderText>Last Transactions</HeaderText>
        </Header>
        <SubContainer>
          <SubHeader>
            <SubHeaderText>Payment Number</SubHeaderText>
            <SubHeaderText>Amount</SubHeaderText>
            <SubHeaderText>Status</SubHeaderText>
          </SubHeader>
          <NoTransaction>No transaction yet</NoTransaction>
          <Transaction>
            <TransactionText>
              <MdPayment size={25} color="lightgreen"/> Payment for house
            </TransactionText>
            <Amount>N76768</Amount>
            <Status>Paid</Status>
          </Transaction>
        </SubContainer>
      </Container>
    );
  }
}

const Container = styled.div`
  width: 100%;
  height: max-content;
  margin-top: 1rem;
`;

const Header = styled.div`
  width: 100%;
`;

const HeaderText = styled.h4`
  width: 80%;
  color: #0a0b69;
`;

const SubContainer = styled.div`
  width: 100%;
  height: max-content;
  background: linear-gradient(to bottom right, #e6e4ff 0%, #e6e4ff 70%);
  margin-top: 1rem;
  padding: 1rem 2rem;
  border-radius: 1rem;
`;

const SubHeader = styled.div`
  width: 100%;
  background-color: white;
  height: 2rem;
  border-radius: 2rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 3rem;
`;

const SubHeaderText = styled.h6`
  color: #0a0b69;
  font-weight: 900;
`;

const NoTransaction = styled.h6`
  color: #0a0b69;
  font-weight: 900;
  text-align: center;
  padding-left: 9%;
`;

const Transaction = styled.div`
  display: flex;
  height: 2rem;
  justify-content: space-around;
  align-items: center;
`;
const TransactionText = styled.h6`
  color: #0a0b69;
  font-weight: 900;
`;
const Amount = styled.h6`
  color: lightgreen;
  font-weight: 900;
`;
const Status = styled.h6`
  color: lightgreen;
  font-weight: 900;
  background-color: #f0f0f0;
  padding: 0.3rem 1rem;
  border-radius: 0.4rem;
`;
export default Transactions;
